import { render } from "./JFpurchase.vue?vue&type=template&id=0c56758c&scoped=true"
import script from "./JFpurchase.vue?vue&type=script&lang=js"
export * from "./JFpurchase.vue?vue&type=script&lang=js"

import "./JFpurchase.vue?vue&type=style&index=0&id=0c56758c&lang=scss&scoped=true"
import "./JFpurchase.vue?vue&type=style&index=1&id=0c56758c&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c56758c"]])

export default __exports__